export const FIND_SPOT_LIST_FAILURE = 'FIND_SPOT_LIST_FAILURE';

export const findSpotListFailure = (payload: Error) => ({
    type: FIND_SPOT_LIST_FAILURE,
    payload,
    error: true,
});
